import parse, { domToReact, HTMLReactParserOptions } from "html-react-parser";
import { useEffect, useState } from "react";
import { useAppContext } from "../../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../../controller/article/ArticleController";
import EnumArticleReviewStatus from "../../../../utils/enum/EnumArticleReviewStatus";
import { handleErrorMessage } from "../../../../utils/Utils";

interface TabReviewServiceType {
  reviewList: any;
  expandObject: any;
  isExpanded: Function;
  setIsExpanded: Function;
  postRating: Function;
  makeReact: Function;
}

export default function TabReviewService({ articleId }: any): TabReviewServiceType {
  const { axiosGetArticleReviewers, axiosRateReview }: ArticleControllerType = ArticleController();
  const [reviewList, setReviewList] = useState([]);
  const [expandObject, setExpandObject] = useState<any>([]);
  const { showMessage } = useAppContext();

  useEffect(() => {
    if (articleId) {
      getArticleReviewers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleId]);

  const getArticleReviewers = () => {
    axiosGetArticleReviewers(articleId)
      .then((res: any) => {
        const newData = res.data.filter((reviewer: any) => reviewer.status === EnumArticleReviewStatus.COMPLETED);
        setReviewList(newData.filter((obj: any) => obj.review));
        makeExpandObj(newData);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const makeExpandObj = (reviewList: Array<any>) => {
    let array: any = [];
    reviewList.forEach((review: any) => {
      array.push({ email: review.reviewer.email, expanded: false });
    });
    setExpandObject(array);
  };

  const isExpanded = (array: any, email: string) => {
    for (let i of array) {
      if (i.email === email) {
        return i.expanded;
      }
    }
  };

  const setIsExpanded = (array: any, email: any, value: any) => {
    for (let i of array) {
      if (i.email === email) {
        return (i.expanded = value);
      }
    }
  };

  const postRating = (reviewId: any, rating: any) => {
    axiosRateReview(articleId, reviewId, rating)
      .then((response: any) => {
        getArticleReviewers();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      if (domNode.name === "pre") {
        return <p>{domToReact(domNode.children, options)}</p>;
      }
    },
  };

  const makeReact = (text: string) => {
    return parse(text, options);
  };

  return {
    reviewList,
    expandObject,
    isExpanded,
    setIsExpanded,
    postRating,
    makeReact,
  };
}
export type { TabReviewServiceType };
